<script lang="ts">
/*
Entry screen- to make an entry- food ate, sleep, exercise, mood, etc
*/

import CategoryData from '@/ts/DataTypes/CategoryData';
import Data from '@/ts/Data';
import { defineComponent } from 'vue'
import Category from './Category.vue';

import StaticVars from '@/ts/StaticVars';
import Entry from '@/ts/DataTypes/Entry';
import { db} from '../ts/DexieDB';
import InputTextSmartVue from './InputTextSmart.vue';
import ButtonVue from './Button.vue';

export default defineComponent({
    components: { InputTextSmartVue, ButtonVue },
    props: {
        //have to have this as a variable in the router/index.ts to actually get it: /:category
        //and can't share data- only strings between components if using vue router
        SwitchScreen: { type: Function, default: () => { console.log("it didn't pass func correctly"); } },
        category: { type: String },
        extra: { type: Object, default: {} }
    },
    data() {
        return {
            // icon:{ type:String, default:"home"},
            // text:{ type:String, default:"Go Home"}
            cat: new CategoryData(0),
            text: "",
            /* previous_entries:[
                {name:"bacon", date_updated:(new Date(new Date().setHours(new Date().getHours()-12)))},
                {name:"beans", date_updated:(new Date(new Date().setHours(new Date().getHours()-39)))},
                {name:"tacos", date_updated:(new Date(new Date().setHours(new Date().getHours()-28)))},
                {name:"eggs", date_updated:(new Date(new Date().setHours(new Date().getHours()-22)))},
                {name:"pizza", date_updated:(new Date(new Date().setHours(new Date().getHours()-2)))},
                {name:"crab", date_updated:(new Date(new Date().setHours(new Date().getHours()-16)))},
                {name:"orange", date_updated:(new Date(new Date().setHours(new Date().getHours()-18)))},
            ] */
            // previous_entries:new Array
            render_input:true,
            refresh_key:0, //to allow vue to refresh when it notices this change
        };
    },
    mounted() 
    {
        console.log("entry screen mounted ! extra:", this.extra);
        //stuff passed in as extra data from "ChooseCategory"
        let cat = Data.GetCategoryById(this.extra.id) as CategoryData;
        console.log("cat ", cat);
        // this.cat = cat;
        // this.previous_entries=[];
        // setTimeout(()=>{
        //     console.log("updating prev entries");this.previous_entries= [...cat.entries];
        //     StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");
        //     this.$forceUpdate();
        // }, 1000);
        
        // StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");
        

        // this.$nextTick(() => 
        // {
        //     this.previous_entries= [...cat.entries];
        //     console.log("this previous_entries233: ", this.previous_entries);
        //     this.$forceUpdate();
        //     StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");
        // });
        
        
        

        console.log("this.cat: ", this.cat);
        //have the text box focused...
        
        // this.$refs.text.focus();
        
        /* console.log("entry screen mounted!", this.category);
        let cat_obj = JSON.parse(this.category as string);
        // this.category.name="updated!";
        // let cats = await Data.GetCategories();
        this.cat = (Data.GetCategoryById(cat_obj.id) as CategoryData);
        // this.cat.name="updated";
        console.log("changed cats 0 name to: ", this.cat.name); */
        //ONLY REAL WAY TO GET THE CURRENT ROUTE
        //finally- the only thing that will allow you to get the current route
        // this.$router.isReady().then(async() => 
        // {
        // });
    },
    computed: {
        placeholder() {
            console.log("placeholder: category: ", this.category);
            return "Enter " + this.cat.name;
        },
        PrevEntries()
        {
            let cat = Data.GetCategoryById(this.extra.id) as CategoryData;
            console.log("PrevEntries: ", cat.entries);
            this.refresh_key;//if this changes, vue will realize it, and actually re-compute
            return [...cat.entries];
        }
    },
    methods: {
        async AddNewEntry() 
        {
            console.log("adding new entry", this.text);
            // router.push({name:"choosecategory", params:{state:"Added "+this.text+" to category"+this.cat.name}});
            // this.cat.name="updated"
            //-1 id originally, until we get one from the database
            // this.cat.entries?.push(new Entry(-1, this.text));
            await Data.AddEntryOld(this.cat, this.text);
            // let input = (this.$refs.input_smart as typeof InputTextSmartVue);
            this.ForceReRender();
            this.refresh_key++;//try to force vue to recompute the computed property- it doesn't monitor when data changes, but just this things own properties

            // input.DataUpdatedExternally();
            // input.
            // this.$forceUpdate();
            // StaticVars.ForceVueUpdate(this, this.previous_entries, "previous_entries");

            // this.SwitchScreen(StaticVars.SCREENS.ChooseCat);
            // this.AddToDB();
            
        },
        ForceReRender()
        {
             // Remove my-component from the DOM
            this.render_input = false;
            console.log("ForceReRender run!!");

            this.$nextTick(() => 
            {
                // Add the component back in
                this.render_input = true;
            });
        },
        Back()
        {
            this.SwitchScreen(StaticVars.SCREENS.ChooseCat);
        },
        TextChanged(text_new:string)
        {
            // console.log("entry screen, text changed = ", text_new);
            this.text=text_new;
        },
        
    },
    
});
</script>

<template>
    <!-- <input type="text" :placeholder="placeholder" v-model="text" ref="text"  @keyup.enter="AddNewEntry"/> -->
    <div class="container">
    <ButtonVue class="btn" text="" type="back" :callback="Back"/>
    <!-- <InputTextSmartVue v-if="render_input" :placeholder="placeholder" :TextChanged="TextChanged" :Submit="AddNewEntry" @keyup.enter="AddNewEntry" :previous_entries_in="PrevEntries" class="smart_input" ref="input_smart"/> -->
    <!-- <input type="button" value="Add" @click="AddNewEntry"/> -->
    <!-- <ButtonVue class="btn" text="" type="yes" :callback="AddNewEntry"/> -->
    </div>
</template>

<style scoped>
.container
{
    display: flex;
    width:100%;
    gap:10px;
    flex-direction: column;
    margin-top:10px;
    /* align-content: flex-start; */
}
.btn
{
    align-self: flex-start;
    height:.5in;
    /* flex-basis:20%; */
    margin:0;
    width:100%;
}
/* .btn:first-of-type
{
    flex-basis:10%;
} */
.smart_input
{
    flex-grow: 1;
}
</style>